import { useEffect, lazy, Suspense } from 'react';
import { Box } from '@mui/material';
import { Container } from '~/content/components/Container';
import Scroll from 'react-scroll';
// import Reviews from './reviews';
// import Partner from './partner';
// import Certificates from './certificates';
const Reviews = lazy(() => import('./reviews.tsx'));
const Partner = lazy(() => import('./partner.tsx'));
const Certificates = lazy(() => import('./certificates.tsx'));

import { trackPageview } from '~/utils/plausible';

const network = (): JSX.Element => {
	useEffect(() => {
		trackPageview();
	}, []);

	useEffect(() => {
		const scroller = () => {
			Scroll.scroller.scrollTo('partner', {
				duration: 1500,
				delay: 250,
				smooth: true,
			});
		};

		const urlParams = new URLSearchParams(window.location.search);

		if (urlParams.get('scrollTo') === 'partner') {
			scroller();
		}
	}, []);

	return (
		<>
			{/* <Hero /> */}

			<Box>
				<Container>
					<Reviews />
				</Container>
			</Box>

			<Box bgcolor={'alternate.main'}>
				<Container>
					<Box position={'relative'}>
						<Scroll.Element
							name='partner'
							style={{
								position: 'absolute',
								// top: isMd ? -60 : -75
								top: -120,
							}}
						/>
					</Box>

					<Partner />
				</Container>
			</Box>

			<Box>
				<Container>
					<Certificates />
				</Container>
			</Box>

			{/* <Box bgcolor={"alternate.main"}>
        <Container>
          <Search />
        </Container>
      </Box> */}

			{/* <Container>
        <Teaser />
      </Container>
      <Container sx={{ paddingTop: "0 !important" }}>
        <Articles />
      </Container>
      <Box bgcolor={"alternate.main"}>
        <Container>
          <FeaturedProperties />
        </Container>
      </Box>
      <Container>
        <Places />
      </Container>
     
      <Container>
        <Partners />
      </Container>
      <Box bgcolor={"alternate.main"}>
        <Container>
          <Advantages />
        </Container>
      </Box>
      <Container>
        <AskExpert />
      </Container> */}
		</>
	);
};

export default network;
